export default {
  data() {
    return {
      allMissionOtherOrganizationInforms: [],
    };
  },
  methods: {
    getAllMissionOtherOrganizationInformsFor800TopListFunction: function (missionId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllMissionOtherOrganizationInforms', missionId).then(() => {
        if (this.$store.state.missionOtherOrganizationInformModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.allMissionOtherOrganizationInforms =
            this.$store.state.missionOtherOrganizationInformModule.allMissionOtherOrganizationInforms;
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionOtherOrganizationInformModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.missionOtherOrganizationInformModule.successFlag) {
                this.getAllMissionOtherOrganizationInformsFor800TopListFunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionOtherOrganizationInformModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllMissionOtherOrganizationInformsFor800TopListFunction(missionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addMissionOtherOrganizationInformsFunction: function (data) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addMissionOtherOrganizationInforms', data).then(() => {
        if (this.$store.state.missionOtherOrganizationInformModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.selectedOtherOrgan = null;
          this.getAllMissionOtherOrganizationInformsFor800TopListFunction(data.missionId);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionOtherOrganizationInformModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.missionOtherOrganizationInformModule.successFlag) {
                this.addMissionOtherOrganizationInformsFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionOtherOrganizationInformModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addMissionOtherOrganizationInformsFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteMissionOtherOrganizationInformFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteMissionOtherOrganizationInform', id).then(() => {
        if (this.$store.state.missionOtherOrganizationInformModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllMissionOtherOrganizationInformsFor800TopListFunction(this.missionId);
          this.snackText = ' سازمان همکار با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.missionOtherOrganizationInformModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteMissionOtherOrganizationInformFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.missionOtherOrganizationInformModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteMissionOtherOrganizationInformFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.missionOtherOrganizationInformModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
